/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FC, Fragment } from 'react';

import useWorkflow, { Step } from 'hooks/useWorkflow';
import Stepper from 'components/Stepper';
import styles from './styles';

interface IncompleteProps {
  /**
   * The current active step.
   */
  step: Step;
}

interface CompletedProps {
  /**
   * Indicate that this is a completed step (not any step in the workflow)
   */
  completed: true;
}

type PropTypes = IncompleteProps | CompletedProps;

/**
 * Display application progress, starting from the CreditApplication page, as a
 * progress bar. It has one more step that the workflow to represent the
 * completion stage (i.e. success, error, pending ,etc)
 */
const ApplicationProgress: FC<PropTypes> = props => {
  const { workflow, steps, stepNumber } = useWorkflow();

  const startStep = workflow.progressStartStep
    ? stepNumber(workflow.progressStartStep)
    : 0;

  // Add one for the completion step.
  const stepCount = steps.length - startStep + 1;

  const activeStep =
    'completed' in props
      ? stepCount - 1
      : (stepNumber(props.step) || 0) - startStep;

  return (
    <Fragment>
      <label css={styles.stepLabel} aria-hidden={true}>
        Step {activeStep + 1} of {stepCount}
      </label>
      <Stepper steps={stepCount} activeStep={activeStep} />
    </Fragment>
  );
};

export default ApplicationProgress;
